import { BsGrid } from 'react-icons/bs'
import { FaArrowRight } from 'react-icons/fa'
import { RxCalendar } from 'react-icons/rx'
import { useNavigate } from 'react-router-dom'
import CardLoader from '../CardProduct/CardLoader'

const LatestArticle = ({ data, isLoading }) => {
  const navigate = useNavigate()

  const handleClick = (item) => {
    navigate(`/articles/${item.slug}`, {
      state: { slug: item.slug, title: item.title }
    })
  }

  return (
    <section className="bg-last-article pt-14 sm:pt-20 pb-24 sm:pb-40 -mt-1 px-4">
      {/* ===== HEADING ===== */}
      <h2 className="text-[22px] sm:text-[28px] md:text-[36px] font-semibold text-center text-white mb-8 sm:mb-16">
        Last Articles
      </h2>

      <div className="w-full max-w-5xl mx-auto">
        {/* ===== GRID ===== */}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 sm:gap-6 md:gap-8">
          
          {/* LOADING */}
          {isLoading && (
            <>
              <CardLoader />
              <CardLoader />
              <CardLoader />
            </>
          )}

          {/* CONTENT */}
          {data?.map((item) => (
            <article
              key={item.id}
              className="
                bg-white rounded-xl overflow-hidden
                shadow-md hover:shadow-2xl
                transition-all duration-300
                touch-manipulation active:scale-[0.98]
              "
            >
              {/* IMAGE */}
              <div className="h-[180px] sm:h-52 overflow-hidden">
                <img
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-[1.03]"
                  src={
                    process.env.REACT_APP_IMAGE + '/article/' + item.image ||
                    '/images/articles/3.png'
                  }
                  alt={item.title || 'article'}
                  loading="lazy"
                />
              </div>

              {/* CONTENT */}
              <div className="p-4 sm:p-5">
                {/* CATEGORY */}
                <div className="flex items-center gap-2 text-[12px] sm:text-[13px] text-secondary">
                  <BsGrid className="text-[#2FAB73]" />
                  <span className="line-clamp-1">
                    {item?.category?.title}
                  </span>
                </div>

                {/* TITLE */}
                <p className="mt-3 mb-4 line-clamp-2 text-[15px] sm:text-[16px] font-semibold text-[#0B132A]">
                  {item.title}
                </p>

                {/* FOOTER */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-[12px] sm:text-[13px] text-secondary">
                    <RxCalendar />
                    <span>{item.published_at.split(' ')[0]}</span>
                  </div>

                  <button
                    onClick={() => handleClick(item)}
                    className="
                      inline-flex items-center gap-2
                      text-[13px] sm:text-[14px]
                      font-medium text-[#2FAB73]
                      hover:text-[#2E7462]
                      transition-colors
                    "
                    aria-label={`Read more ${item.title}`}
                  >
                    Read more
                    <FaArrowRight className="text-[#2E7462]" />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default LatestArticle
